/* istanbul ignore file */

import { AppsSiteManagement } from '../../../models';

export class SiteManagementLogicServiceModel {
    appsSiteManagement: AppsSiteManagement;
    appNames: string[] = [];
    licenseTiers: string[] = [];
}
